import styles from "./styles.css"
import React from "react"
import parentStyles from "../styles.css"
import PropTypes from "prop-types"
import { handleDocument } from "services/utils/mask"

const InputDocument = ({ formik, formValues }) => {
  const { name, placeholder } = formValues
  const { touched, values, errors, handleBlur } = formik
  const isErrorField = touched[name] && errors[name]

  const handleChange = (name, value) => {
    formik.setFieldValue(name, value, true)

    const updatedErrors = { ...errors }

    if (updatedErrors[name]) {
      delete updatedErrors[name]
      formik.setErrors(updatedErrors)
    }
  }

  const handleInputDocument = (e) => {
    const { name, formattedValue } = handleDocument(e)
    handleChange(name, formattedValue)
  }

  return (
    <div className={parentStyles.line}>
      <div className={styles.input_field}>
        <input
          id={name}
          name={name}
          type="text"
          placeholder={placeholder}
          className={`${isErrorField && parentStyles.focus_error}`}
          onChange={(e) => {
            handleInputDocument(e)
          }}
          value={values[name]}
          onBlur={handleBlur}
        />
        {isErrorField && (
          <div className={parentStyles.error}>{errors[name]}</div>
        )}
      </div>
    </div>
  )
}

InputDocument.propTypes = {
  formik: PropTypes.object,
  formValues: PropTypes.object
}

export default InputDocument



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/Inputs/InputDocument/index.js